import React from 'react';
import { Icon } from './Icon.js';
export const IconImages2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 14L18 9H17L11 16", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M18 20L2 20L2 8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 16L6 16L6 4L22 4L22 16Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M10.5 8.49001L10.5 8.50001", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconImages2.js.map